import { render, staticRenderFns } from "./A-dashboard.vue?vue&type=template&id=6f313c0a&scoped=true&"
import script from "./A-dashboard.vue?vue&type=script&lang=js&"
export * from "./A-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./A-dashboard.vue?vue&type=style&index=0&id=6f313c0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f313c0a",
  null
  
)

export default component.exports